// pages/PatientMessages.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { ArrowLeft, MessageCircle } from "lucide-react";

import { auth } from "../firebase";
import TelehealthInbox from "../components/telehealth/TelehealthInbox";

export default function PatientMessages() {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);

  if (!user) {
    return (
      <div
        style={{
          padding: 16,
          maxWidth: 420,
          margin: "0 auto",
          fontFamily:
            '-apple-system,BlinkMacSystemFont,"SF Pro Text","SF Pro Display",system-ui,"Segoe UI",Roboto,Helvetica,Arial,sans-serif',
          fontSize: 14,
          color: "#4B5563",
        }}
      >
        Duhet të hysh në llogarinë tënde për të parë mesazhet me mjekët.
      </div>
    );
  }

  return (
    // FULL-WIDTH WRAPPER (background + mobile-first)
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        padding: "16px 0 24px",
        boxSizing: "border-box",
        background: "#F3F4F6",
        overflowX: "hidden",
        fontFamily:
          '-apple-system,BlinkMacSystemFont,"SF Pro Text","SF Pro Display",system-ui,"Segoe UI",Roboto,Helvetica,Arial,sans-serif',
      }}
    >
      {/* MOBILE COLUMN */}
      <div
        style={{
          maxWidth: 480,
          margin: "0 auto",
          padding: "0 12px",
          boxSizing: "border-box",
        }}
      >
        {/* TOP HEADER (back + title) */}
        <header
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            marginBottom: 12,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            {/* back button */}
            <button
              type="button"
              onClick={() => navigate(-1)}
              style={{
                width: 32,
                height: 32,
                borderRadius: 999,
                border: "1px solid #E5E7EB",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#FFFFFF",
                cursor: "pointer",
              }}
            >
              <ArrowLeft
                style={{ width: 18, height: 18, color: "#4B5563" }}
              />
            </button>

            {/* title + subtitle */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: 2 }}
            >
              <span
                style={{
                  fontSize: 14,
                  fontWeight: 600,
                  color: "#0F172A",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <MessageCircle
                  style={{ width: 18, height: 18, color: "#0F766E" }}
                />
                Mesazhet me mjekët
              </span>
              <span
                style={{
                  fontSize: 12,
                  color: "#6B7280",
                }}
              >
                Komunikimi i sigurt me mjekët për vizitat dhe konsultat
                online.
              </span>
            </div>

            <div style={{ flex: 1 }} />
          </div>
        </header>

        {/* TELEHEALTH INBOX (patient mode) */}
        <div style={{ marginTop: 4 }}>
          <TelehealthInbox mode="patient" />
        </div>
      </div>
    </div>
  );
}
